import React, { useEffect, useState } from "react";
import { Handle } from "reactflow";
import "./CustomeNodeData.css";
import {
  fetchAnonProtocols,
  fetchFilters,
  fetchPacsConfiguration,
  fetchPlatformConfigs,
} from "../Modal/Utility";

const CustomNodeHL7Sender = ({ data }) => {

  // console.log("hl7sender",data)
  return (
    <div className="custom-node">
      <div className="node-header">HL7 SENDER</div>

      <div className="name">{data?.nodes?.name}</div>

      <div >IP:{data?.nodes?.ip}</div>

      <div >PORT:{data?.nodes?.port}</div>

      <div>VERSION:{data?.nodes?.version}</div>

      <Handle type="target" position="left" />
      <Handle type="source" position="right" />
    </div>
  );
};

export default CustomNodeHL7Sender;
